const FEATURES = [
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    desc: '被窝影院官网提供安全可靠的观影环境，最新地址首页直达。无弹窗广告干扰，无恶意跳转，保障您的设备安全与隐私。多年稳定运营，用户可以放心使用。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清流畅',
    desc: '采用智能CDN加速技术，多线路自动调度，确保高清画质下依然流畅不缓冲。支持1080P和4K超清画质，自适应带宽，为您带来影院级的观影享受。',
  },
  {
    icon: 'ri-movie-line',
    title: '海量资源',
    desc: '收录超过20000部电影电视剧资源，覆盖动作、喜剧、爱情、悬疑、科幻、动漫、纪录片等全类型。每日滚动更新，热门新片第一时间上线，经典老片随时回顾。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3 whitespace-nowrap">
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            为什么选择被窝影院
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            三大核心优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={i}
              className="text-center p-8 bg-background-100 rounded-2xl border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-primary-50 flex items-center justify-center">
                <i className={`${f.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 font-heading mb-3">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}